import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserPortfolios } from '../../../Auth/Admin/utilities/adminUtils';
import { useAuth } from '../../../Auth/context/AuthContext';
import PageContainer from '../../../PageUtil/PageContainer';

const UserPortfolios = () => {
  const { isAdmin } = useAuth();
  const { userId } = useParams();
  const [portfolios, setPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const loadPortfolios = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getUserPortfolios(userId);
      setPortfolios(data);
    } catch (err) {
      console.error('Error loading portfolios:', err);
      setError('Failed to load portfolios');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (isAdmin) {
      void loadPortfolios();
    } else {
      navigate('/dashboard');
    }
  }, [isAdmin, loadPortfolios, navigate]);

  return (
    <PageContainer error={error} setError={setError} isAdmin={isAdmin}>
      <div className="py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h3 mb-0">Portfolios for User: {userId}</h1>
          <button className="btn btn-outline-secondary" onClick={() => navigate('/admin/users')}>
            <i className="bi bi-arrow-left me-2"></i>Back to Users
          </button>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row g-4">
            {portfolios.length > 0 ? portfolios.map(p => (
              <div key={p.id} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm hover-lift">
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="card-title mb-0 text-truncate">{p.title || p.id}</h5>
                      <span className={`badge ${p.type === 'Published' ? 'bg-success' : 'bg-warning text-dark'}`}>
                        {p.type}
                      </span>
                    </div>
                    <p className="small text-muted mb-3">ID: {p.id}</p>
                    <div className="mt-auto">
                      <button 
                        className="btn btn-sm btn-outline-primary w-100"
                        onClick={() => navigate(`/${userId}/${p.type.toLowerCase()}/view/${encodeURIComponent(p.id)}`)}
                      >
                        <i className="bi bi-eye me-1"></i> View Portfolio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted">This user has no portfolios.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default UserPortfolios;
